import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

type Input = {
  unityId: string
}

const getContracts = async ({ unityId }: Input): Promise<any> => {
  return axios.get(`financial/contracts/${unityId}`)
}

export function useGetContracts({ unityId }: Input) {
  return useQuery(['get-contracts', unityId], () => getContracts({ unityId }), {
    // refetchOnWindowFocus: true,
    // cacheTime: 0,
    // staleTime: 0,
    enabled: !!unityId,
    onSuccess: (data) => {
      return data
      // toast.success('Simulação solicitada!')
    },
    onError: (error: any) => {
      let msg = 'Não foi possível obter os contratos.'
      if (error?.response?.data?.message) msg = error?.response?.data?.message

      toast.error(`${msg}`, {
        toastId: 'get-contracts'
      })
    }
    // console.log('Não foi possível obter os contratos.')
  })
}
